import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { logError } from '@/utils/logger';

const API = process.env.REACT_APP_BACKEND_URL;
const AUTH = { withCredentials: true };

export function useAdminCustomers(user, setError) {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCustomers = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/api/admin/customers`, AUTH);
      setCustomers(data.customers);
    } catch (err) {
      logError('Customers', err);
      setError('Failed to load customer accounts.');
    } finally {
      setLoading(false);
    }
  }, [setError]);

  useEffect(() => { if (user) fetchCustomers(); }, [user, fetchCustomers]);

  const setStatus = async (userId, status) => {
    try {
      await axios.patch(`${API}/api/admin/customers/${userId}/status`, { status }, AUTH);
      setCustomers((prev) => prev.map((c) => (c.user_id === userId ? { ...c, status } : c)));
    } catch (err) {
      logError('CustomerStatus', err);
      setError('Failed to update the customer account.');
    }
  };

  const pending = customers.filter((c) => c.status === 'pending').length;
  return { customers, loading, setStatus, pending, refresh: fetchCustomers };
}
